export default __webpack_public_path__ + "static/media/bewilder.c604c4da.png";